// extracted by mini-css-extract-plugin
module.exports = {"accordion":"_2HxGrPTw"};